<template>
    <main class="m-composable-ai">
        <y-container>
            <y-hero
                v-if="heroContent"
                class="m-composable-ai__hero"
                :content="heroContent"
            />
        </y-container>

        <div
            v-if="heroContent"
            class="m-composable-ai__benefits-slider"
        >
            <div class="m-composable-ai__slider-wrapper--hidden">
                <y-container>
                    <y-in-action-slider :content="heroContent" />
                </y-container>
            </div>
        </div>

        <div
            v-if="heroContent"
            class="m-composable-ai__video"
        >
            <y-container>
                <y-pwa-video
                    iframe
                    :streaming-data="videoData"
                    dont-show-content
                />
            </y-container>
        </div>

        <div v-if="mainContent">
            <y-container>
                <y-use-cases :content="mainContent" />
            </y-container>
        </div>

        <div
            v-if="testemonials && mainContent"
            class="m-composable-ai__integrate"
        >
            <y-container>
                <y-integrate
                    :clients-say="testemonials"
                    :content="mainContent"
                />
            </y-container>
        </div>
    </main>
</template>

<script >
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import YPwaVideo from '@modules/pwa/components/PwaVideo/Index.vue';
    import YHero from '@modules/video-audio/components/Hero/Hero.vue';
    import YUseCases from '@modules/video-audio/components/UseCases/Index.vue';
    import YInActionSlider from '@modules/api/components/InActionSlider/InActionSlider.vue';
    import YIntegrate from '@modules/video-audio/components/Integrate/Integrate.vue';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    export default {
        name: 'ComposablePage',

        components: {
            YHero,
            YPwaVideo,
            YUseCases,
            YInActionSlider,
            YIntegrate,
        },

        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                heroContent : '',
                videoData   : {},
                mainContent : '',
                testemonials: '',
            };
        },

        /**
         *
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            removeSymbol,

            /**
             * Fetch home data
             *
             * @returns {Promise}
             */
            fetch() {
                const hero = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'video-audio-images-hero',
                    including: ['albums', 'title2', 'image', 'title', 'synopsis', 'custom', 'seo_meta_description', 'seo_post_title', 'header_image', 'description'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const mainContent = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'video-audio-images-explore',
                    including: ['albums', 'title2', 'image', 'title', 'synopsis', 'custom', 'seo_meta_description', 'seo_post_title', 'header_image', 'description'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const clientsSay = this.$services.Content.postList({
                    type     : 'testimonials',
                    including: ['title', 'title2', 'header_image', 'image', 'synopsis'],
                    locale   : this.$i18n.locale,
                    tagging  : 'video-audio-images',
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all(
                    [hero, mainContent, clientsSay],
                ).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.heroContent = responses[0].data.results;
                        this.videoData = {
                            title               : responses[0].data.results.custom.field4,
                            image               : responses[0].data.results.header_image,
                            albums              : responses[0].data.results.albums.filter((item) => item.group === 'video'),
                            seo_canonical       : responses[0].data.results.seo_canonical,
                            seo_meta_description: responses[0].data.results.seo_meta_description,
                            seo_post_title      : responses[0].data.results.seo_post_title,
                            custom              : {
                                'button-title': responses[0].data.results.custom.field5,
                                'button-link' : responses[0].data.results.custom.field6,
                                embed_link    : responses[0].data.results?.custom?.field7,
                            },
                        };
                    }
                    if (this.handleReq(responses, 1)) {
                        this.mainContent = responses[1].data.results;
                    }
                    if (this.handleReq(responses, 2)) {
                        this.testemonials = responses[2].data.results;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };

</script>

<style lang="scss" src="../scss/video-audio.scss"/>
